import React from "react";

export type EnvironmentListTab = "compute" | "applications";

const EnvironmentListTabs: React.FC<{
  activeTab: EnvironmentListTab;
  onChange: (tab: EnvironmentListTab) => void;
}> = ({ activeTab, onChange }) => (
  <div className="border-b border-zinc-800">
    <div className="flex gap-6" role="tablist" aria-label="Compute views">
      {(["compute", "applications"] as const).map((tab) => (
        <button
          key={tab}
          type="button"
          onClick={() => onChange(tab)}
          role="tab"
          aria-selected={activeTab === tab}
          aria-controls={`${tab}-panel`}
          id={`${tab}-tab`}
          className={`border-b-2 pb-3 text-sm ${
            activeTab === tab
              ? "border-highlight font-semibold text-white"
              : "border-transparent text-secondary hover:text-white"
          }`}
        >
          {tab === "compute" ? "Compute" : "Applications"}
        </button>
      ))}
    </div>
  </div>
);

export default EnvironmentListTabs;
